"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initHelpScout = initHelpScout;
function initHelpScout() {
    const isChatSupportOn = false;
    window.Beacon('init', '8d720498-3545-4a82-8a53-ec0de005dcfc');
    window.Beacon('config', { messaging: { chatEnabled: isChatSupportOn } });
}
